import { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import OperationLogDrawer from '@/components/common/OperationLogDrawer';
import { useOperationLogDrawerHost } from '@/components/common/operationLogDrawerHostContext';
import './OperationLogDrawerTrigger.less';

const recordIcon = (
    <span className="anticon">
        <i className="bi bi-arrow-bar-left" />
    </span>
);

/**
 * 操作记录入口 + 列表抽屉
 * @param {number|string|null} entityId 正整数时展示入口
 * @param {'fixed'|'inline'} placement fixed：内容区右上角（机构库同款）；inline：普通链接按钮
 *
 * 宿主全屏 Drawer 外层须包 OperationLogDrawerHostProvider，避免操作记录 Drawer 嵌套在宿主子树内触发 rc-drawer push。
 */
export default function OperationLogDrawerTrigger({ entityId, entityType, module, buttonText = '操作记录', maskClosable = true, placement = 'fixed' }) {
    const host = useOperationLogDrawerHost();
    const [localOpen, setLocalOpen] = useState(false);
    const idNum = Number(entityId);
    if (!Number.isFinite(idNum) || idNum <= 0) {
        return null;
    }

    const isFixed = placement === 'fixed';

    const openDrawer = () => {
        if (host) {
            host.open({ entityType, entityId: idNum, module, maskClosable });
            return;
        }
        setLocalOpen(true);
    };

    const recordButton = (
        <Button type="link" onClick={openDrawer} icon={isFixed ? recordIcon : undefined} className={isFixed ? 'applog-record-btn' : undefined}>
            {buttonText}
        </Button>
    );

    return (
        <>
            {isFixed ? <div className="applog-record-toolbar">{recordButton}</div> : recordButton}
            {!host ? <OperationLogDrawer open={localOpen} onClose={() => setLocalOpen(false)} entityType={entityType} entityId={idNum} module={module} maskClosable={maskClosable} /> : null}
        </>
    );
}

OperationLogDrawerTrigger.propTypes = {
    entityId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    entityType: PropTypes.string.isRequired,
    module: PropTypes.string.isRequired,
    buttonText: PropTypes.string,
    maskClosable: PropTypes.bool,
    placement: PropTypes.oneOf(['fixed', 'inline']),
};
